<template>
<div class="studentStatistics">
  <p class="title">作业报告</p>
  <div class="contentReport">
  <rankHeader :classList="classList" :className="className" :wechatUrl="wechatUrl" :startDate="startDate" :endDate="endDate" :shareFlag="true" @changClassId="changClassId" 
  @changedPicker="changedPicker" @getWorkStatistics="getWorkStatistics">
  </rankHeader>
  <div class="scoreTable" v-if="!studentScore.length">
    <noFound></noFound>
  </div>
  <div class="scoreTable" v-else>
    <table cellspacing='0'>
      <thead>
        <tr>
          <th>成绩排名</th>
          <th>姓名</th>
          <th>提交率</th>
          <th>
            得分
            <el-popover placement="bottom" width="200" trigger="hover" content="时间段内，学生作业得分，换算成百分制。">
                <i class="iconQMark" slot="reference"></i>
            </el-popover>
          </th>
          <th>作业时长</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in studentScore">
          <td>{{item.ranking}}</td>
          <td>{{item.userName}}</td>
          <td>{{item.submitRate}}%</td>
          <td>{{item.avgScore}}</td>
          <td>{{item.totalTime | secTotime1}}</td>
          <td class="watchInfo" @click="lookOneStudent(item)">
            查看详情
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
</div>
</template>
<script>
import fetch from "./../fetch";
import { brandId, http, clientId, httpApp} from "./../config";
import rankHeader from "./../components/reportTable/header.vue";
import noFound from "./../components/noData/nodata.vue";
export default {
  data() {
    return {
      classList: [],
      classId: '',
      className: '',
      startDate: '',
      endDate: '',
      studentScore: [],
      wechatUrl: ''
    };
  },
  components: {
    rankHeader,
    noFound
  },
  created() {
    this.$nextTick(() => {
      let classList = window.sessionStorage.getItem('studentsListData')
      this.classList = classList ? JSON.parse(classList) : []
      if (!this.classList.length) {
        return false
      }
      let routerData = this.$route.query
      if (routerData.classId) {
          this.classList.map(item => {
             if (item.classId == routerData.classId) {
               this.classId = item.classId * 1
               this.className = item.className
             }
          })
          this.startDate = routerData.startDate * 1000
          this.endDate = routerData.endDate * 1000
          this.getWorkStatistics()
      } else {
        this.classId = this.classList[0].classId
        this.className = this.classList[0].className
        this.setInitTime()
        this.getWorkStatistics()
      }
    })
  },
  methods: {
    setInitTime() {
      let nowdate = new Date()
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth();
      let d = nowdate.getDate();
      let formatwdate = y + '-' + m + '-' + (d - 1) + ' 23:59:59';
      let maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59'
      this.endDate = Date.parse(maxTime)
      this.startDate = Date.parse(formatwdate)
      this.timeFlag = true
    },
    changedPicker (data) {
      this.startDate = data.startDate
      this.endDate = data.endDate
    },
    getWorkStatistics () {
      if (this.endDate - this.startDate > 2678400000) {
        this.$toast('统计报告时间段最长选择1个月（31天）', 'error')
        return false
      }
     this.wechatUrl = ''
     let startDate = this.startDate / 1000
     let endDate = this.endDate / 1000
     let redirectUrl = encodeURIComponent(`${httpApp}/genearch/#/studyWeekly?startDate=${startDate}&endDate=${endDate}`)
     let wechatUrl = `${httpApp}/wechat/v4/redirect?state=8&actionId=6&redirectUrl=${redirectUrl}`
     this.wechatUrl = wechatUrl
     this.getstudentS()
    }, 
    changClassId(data) {
      console.log(data.classId, 'changClassId')
      this.classId = data.classId
      this.className = data.className
    },
    getstudentS () {
      console.log(this.classId, 'getstu')
      let params = {
        classId: this.classId,
        startDate: this.startDate / 1000,
        endDate: this.endDate / 1000
      }
      fetch.getStudentWorkReport(params).then(res => {
        if (!res) {
          return false
        }
        this.studentScore = res.data
      })
    },
    lookOneStudent (data) {
      let routerUrl = {
        userId: data.userId,
        classId: this.classId,
        startDate: this.startDate / 1000,
        endDate: this.endDate / 1000,
        index: data.ranking
      }
      this.$router.push({name: "oneStudentReport", query: routerUrl});
    }
  }
};
</script>



// WEBPACK FOOTER //
// studentReport.vue?7f91a8fc